import styled from '@emotion/styled'
import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from 'react-i18next'
import { Link, useLoaderData } from 'react-router'

import { Button, Grid, LinearProgress, Divider as MuiDivider, Typography } from '@mui/material'

import { spacing } from '@mui/system'
import useAuth from '../../../hooks/useAuth'
import ConvertibleBasicInfo from './ConvertibleBasicInfo'
import InfoBlock from '../../components/InfoBlock'
import ConvertibleEvents from './ConvertibleEvents'
import ConvertibleInvestors from './ConvertibleInvestors'
import ConvertibleOtherInfo from './ConvertibleOtherInfo'
import { EntityNoteButton } from '../../components/EntityNoteButton'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import { WatchListButton } from '../../components/WatchListButton'

const Divider = styled(MuiDivider)(spacing)

function ConvertibleDetails() {
    const { user } = useAuth()
    const { t } = useTranslation()
    const convertible: ConvertibleEntity = useLoaderData()

    const convertibleName = convertible.convertibleName

    return (
        <>
            <Helmet
                title={t('site.convertibles.detailsTitle', {
                    name: convertibleName,
                })}
            />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'inline',
                }}
            >
                {t('site.convertibles.detailsTitle', { name: convertibleName })}
                <WatchListButton
                    entityId={convertible.id}
                    isInWatchList={!!convertible.isInWatchList}
                    type='Convertible'
                />
                <EntityNoteButton entityId={convertible.id} type='convertible' />
            </Typography>
            {user?.groups?.includes('superadmin') && (
                <>
                    <Button variant='text' to={`/admin/convertibles/${convertible?.id}`} LinkComponent={Link}>
                        [Redigera]
                    </Button>

                    <Button
                        variant='text'
                        to={`/admin/pr-company?companyId=${convertible.companyId}`}
                        LinkComponent={Link}
                    >
                        [Visa admin pm]
                    </Button>
                </>
            )}
            <Divider my={6} />
            <Grid container spacing={6}>
                <Grid size={12}>
                    {!convertible && <LinearProgress />}
                    {convertible && (
                        <Grid container spacing={6}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Om konvertibellånet'>
                                    <ConvertibleBasicInfo convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Händelser'>
                                    <ConvertibleEvents convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <ConvertibleInvestors convertible={convertible} />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <InfoBlock title='Övrigt'>
                                    <ConvertibleOtherInfo convertible={convertible} />
                                </InfoBlock>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    )
}

export default ConvertibleDetails
